import React from 'react';
import './contactformsvg.css';
import PropTypes from 'prop-types';

export default function Contactformsvg(props) {
  const theme = props.theme;

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 396.83 388.61"
        className="contactform-main-svg">
        <defs>
          <style></style>
        </defs>
        <g id="Device">
          <g id="Device-2" data-name="Device">
            <g id="Mobile">
              <path
                className="cls-1"
                d="M14.62,304.77,134.3,373.86a12.9,12.9,0,0,0,12.49.23L387.74,235c3.8-2.19,6.87-7.1,6.88-10.95s-3.08-8.76-6.88-11L268.5,144.23a15.19,15.19,0,0,0-13.74,0L14.62,282.87c-3.8,2.2-6.88,7.1-6.88,10.95S10.82,302.58,14.62,304.77Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M134.3,373.86,14.62,304.77c-3.8-2.19-6.88-7.09-6.88-10.95s3.08-8.75,6.88-10.95L140.81,210V375.57A12.69,12.69,0,0,1,134.3,373.86Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-3"
                d="M137.15,361.55a13.47,13.47,0,0,0,12.12,0l238.5-137.7c5.13-3,5.13-7.81,0-10.77L268.51,144.23a15.19,15.19,0,0,0-13.74,0L14.63,282.87c-3.78,2.19-3.78,5.76,0,7.94Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M148.73,347.68a14.39,14.39,0,0,0,13.06,0L367,229.19c3.61-2.08,3.61-5.46,0-7.54L254.83,156.89a14.45,14.45,0,0,0-13.06,0L36.54,275.37c-3.59,2.08-3.59,5.47,0,7.55Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M248.69,155.35a13.22,13.22,0,0,1,6.14,1.54L367,221.65c3.61,2.08,3.61,5.46,0,7.54L344.78,242l-96.09-61.36Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M241.69,161.79a14.45,14.45,0,0,1,13.06,0l112.19,64.76a6.8,6.8,0,0,1,1.71,1.37,6.59,6.59,0,0,1-1.63,1.27L161.79,347.68a14.39,14.39,0,0,1-13.06,0L36.54,282.92a6.68,6.68,0,0,1-1.7-1.36,6.55,6.55,0,0,1,1.62-1.28Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M326,191.36l-19.88-11.48c-1.19-.69-1.25-1.76-.14-2.4a4.61,4.61,0,0,1,4.17.07L330,189c1.19.69,1.25,1.76.13,2.41A4.62,4.62,0,0,1,326,191.36Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M291.87,171.68a1.23,1.23,0,0,1,0-2.33,4.47,4.47,0,0,1,4,0,1.23,1.23,0,0,1,0,2.33A4.47,4.47,0,0,1,291.87,171.68Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M283.81,167a1.23,1.23,0,0,1,0-2.33,4.47,4.47,0,0,1,4,0,1.23,1.23,0,0,1,0,2.33A4.47,4.47,0,0,1,283.81,167Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M348.29,204.25a1.23,1.23,0,0,1,0-2.33,4.47,4.47,0,0,1,4,0,1.23,1.23,0,0,1,0,2.33A4.47,4.47,0,0,1,348.29,204.25Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M340.23,199.59a1.23,1.23,0,0,1,0-2.33,4.47,4.47,0,0,1,4,0,1.23,1.23,0,0,1,0,2.33A4.47,4.47,0,0,1,340.23,199.59Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Mail_Notification" data-name="Mail Notification">
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M143.72,314.59V315a2.4,2.4,0,0,0,1.08,1.89l23.35,13.48a2.46,2.46,0,0,0,2.18,0L209,308.07a2.42,2.42,0,0,0,1.08-1.89v-.43a2.4,2.4,0,0,0-1.08-1.89l-23.35-13.48a2.46,2.46,0,0,0-2.18,0L144.8,312.7A2.4,2.4,0,0,0,143.72,314.59Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M143.72,314.59V315a2.4,2.4,0,0,0,1.08,1.89l23.35,13.48a2.46,2.46,0,0,0,2.18,0L209,308.07a2.42,2.42,0,0,0,1.08-1.89v-.43a2.4,2.4,0,0,0-1.08-1.89l-23.35-13.48a2.46,2.46,0,0,0-2.18,0L144.8,312.7A2.4,2.4,0,0,0,143.72,314.59Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-6"
                d="M209,303.86l-23.35-13.48a2.46,2.46,0,0,0-2.18,0l-14.22,8.22v32h0a2.28,2.28,0,0,0,1.09-.26L209,308.07a2.42,2.42,0,0,0,1.08-1.89v-.43A2.4,2.4,0,0,0,209,303.86Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-7"
                d="M209,303.86l-23.35-13.48a2.46,2.46,0,0,0-2.18,0l-14.22,8.22v32h0a2.28,2.28,0,0,0,1.09-.26L209,308.07a2.42,2.42,0,0,0,1.08-1.89v-.43A2.4,2.4,0,0,0,209,303.86Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-6"
                d="M169.24,298.6,144.8,312.7a2.4,2.4,0,0,0-1.08,1.89V315a2.4,2.4,0,0,0,1.08,1.89l23.35,13.48a2.25,2.25,0,0,0,1.09.26h0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M169.24,298.6,144.8,312.7a2.4,2.4,0,0,0-1.08,1.89V315a2.4,2.4,0,0,0,1.08,1.89l23.35,13.48a2.25,2.25,0,0,0,1.09.26h0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M164.41,325.28,144.8,314a.67.67,0,0,1,0-1.26l38.66-22.32a2.46,2.46,0,0,1,2.18,0L209,303.86a.67.67,0,0,1,0,1.26l-6.42,3.7-2.24,1.3-30,17.32a2.39,2.39,0,0,1-2.18,0l-1.9-1.1Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-6"
                d="M164.41,325.28,144.8,314a.67.67,0,0,1,0-1.26l38.66-22.32a2.46,2.46,0,0,1,2.18,0L209,303.86a.67.67,0,0,1,0,1.26l-6.42,3.7-2.24,1.3-30,17.32a2.39,2.39,0,0,1-2.18,0l-1.9-1.1Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-7"
                d="M182.21,306.47,209,303.86l-26.54,1.5,3.19-15a2.42,2.42,0,0,0-1.19-.25l-5,20.25-35.09,2.9a.75.75,0,0,0,.44.68l28.34-1.64-3.9,15.38,5-15.45h0l4.84-.28a2.57,2.57,0,0,0,1.59-.67h0a2.65,2.65,0,0,0,.81-1.4Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-6"
                d="M152.73,312.59l26.72-2.21,1-3.82.53-2.13,3.53-14.3a2.31,2.31,0,0,0-1,.25l-19.33,11.16L144.8,312.7a.8.8,0,0,0-.44.58l5.36-.44Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-9"
                d="M180.13,287.19a9.77,9.77,0,0,1,8.84,0c2.44,1.41,2.44,3.69,0,5.1a9.77,9.77,0,0,1-8.84,0C177.69,290.88,177.69,288.6,180.13,287.19Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M181.46,290.58a.42.42,0,0,1-.18-.06.14.14,0,0,1-.05-.13l.37-1.6s0-.09,0-.15a.25.25,0,0,1,.13-.14l.9-.52a.38.38,0,0,1,.19-.05.39.39,0,0,1,.2.05l4.74,2.73a.12.12,0,0,1,0,.23l-1,.56a.42.42,0,0,1-.2,0,.4.4,0,0,1-.2,0l-3.2-1.85-.21.88c0,.05-.05.08-.11.11a.36.36,0,0,1-.21,0Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Notification">
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M225,297.55l-26.26-15.16c-.6-.35-.6-.91,0-1.25l95.32-55a2.41,2.41,0,0,1,2.16,0l26.27,15.17c.6.34.6.9,0,1.25l-95.32,55A2.37,2.37,0,0,1,225,297.55Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M220,280.42a.52.52,0,0,1-.27.07h-.21l-5.46-.62,3.23,1.87a.13.13,0,0,1,0,.24l-.64.37a.35.35,0,0,1-.21,0,.36.36,0,0,1-.21,0l-5.07-2.92c-.06,0-.09-.08-.09-.13a.15.15,0,0,1,.09-.12l.55-.32a.54.54,0,0,1,.27-.07h.22l5.46.62-3.24-1.87a.13.13,0,0,1,0-.24l.64-.37a.46.46,0,0,1,.21-.05.41.41,0,0,1,.21.05l5.07,2.93a.13.13,0,0,1,0,.24Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M219.65,278.25a2.65,2.65,0,0,1-.69-.55,1.14,1.14,0,0,1-.29-.61,1,1,0,0,1,.16-.62,1.66,1.66,0,0,1,.63-.55,3.42,3.42,0,0,1,.95-.37,4.67,4.67,0,0,1,1.05-.1,5,5,0,0,1,1,.14,3.62,3.62,0,0,1,.9.37l.35.2a.13.13,0,0,1,0,.24l-2.62,1.52a1.26,1.26,0,0,0,.4.14,2,2,0,0,0,.43,0,3.29,3.29,0,0,0,.43-.09,1.9,1.9,0,0,0,.38-.17,1.52,1.52,0,0,0,.36-.26.5.5,0,0,0,.13-.23.32.32,0,0,1,.06-.13.44.44,0,0,1,.12-.1l.63-.36a.46.46,0,0,1,.21-.05.33.33,0,0,1,.21.05.37.37,0,0,1,.16.23.65.65,0,0,1,0,.39,1.25,1.25,0,0,1-.28.49,2.46,2.46,0,0,1-.65.52,3.91,3.91,0,0,1-.95.37,4.56,4.56,0,0,1-1.05.1,4.7,4.7,0,0,1-1-.17A4.61,4.61,0,0,1,219.65,278.25Zm.75-1.79a1.14,1.14,0,0,0-.32.26.5.5,0,0,0-.1.26.39.39,0,0,0,.07.23.52.52,0,0,0,.17.19l1.77-1a2.09,2.09,0,0,0-.3-.11,1.51,1.51,0,0,0-.38-.06,2.18,2.18,0,0,0-.43.05A2.34,2.34,0,0,0,220.4,276.46Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M228.62,273.53l-1.53-1.71a.24.24,0,0,1-.06-.11s0-.08.09-.12l.59-.35a.48.48,0,0,1,.22-.05.46.46,0,0,1,.21.05l0,0,2.44,2.77a.34.34,0,0,1,.06.12s0,.08-.09.13l-.6.34a.36.36,0,0,1-.22.05l-.21,0-2.85-.77,1.33,1.65a.34.34,0,0,1,.06.12s0,.08-.09.12l-.59.35a.37.37,0,0,1-.22.05.71.71,0,0,1-.21,0l-4.8-1.4s0,0-.06,0a.12.12,0,0,1,0-.24l.59-.35a.37.37,0,0,1,.22-.05l.19,0,3,.88-1.49-1.73a.14.14,0,0,1-.05-.11.12.12,0,0,1,.08-.12l.6-.35a.44.44,0,0,1,.21,0,.6.6,0,0,1,.2,0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M232.17,271a2.67,2.67,0,0,1-.69-.56,1.11,1.11,0,0,1-.29-.61.86.86,0,0,1,.15-.61,1.85,1.85,0,0,1,.63-.56,3.61,3.61,0,0,1,1-.37,5.24,5.24,0,0,1,1-.1,4.5,4.5,0,0,1,1,.15,3.26,3.26,0,0,1,.9.36l.35.2q.09.06.09.12c0,.05,0,.09-.09.13l-2.62,1.51a1.07,1.07,0,0,0,.39.14,2.07,2.07,0,0,0,.43,0,1.72,1.72,0,0,0,.44-.09,1.46,1.46,0,0,0,.38-.17,1.28,1.28,0,0,0,.36-.26.57.57,0,0,0,.13-.22.38.38,0,0,1,.05-.14.29.29,0,0,1,.13-.09l.63-.37a.47.47,0,0,1,.42,0,.48.48,0,0,1,.16.24.65.65,0,0,1,0,.39,1.68,1.68,0,0,1-.28.49,2.52,2.52,0,0,1-.66.51,3.42,3.42,0,0,1-1,.37,4,4,0,0,1-1,.1,4.26,4.26,0,0,1-1.06-.17A4.06,4.06,0,0,1,232.17,271Zm.75-1.79a.88.88,0,0,0-.32.26.41.41,0,0,0-.1.26.38.38,0,0,0,.06.23,1,1,0,0,0,.17.18l1.78-1a1.85,1.85,0,0,0-.31-.11,1.44,1.44,0,0,0-.37-.05,1.3,1.3,0,0,0-.43.05A1.4,1.4,0,0,0,232.92,269.24Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M236.25,266.77a.67.67,0,0,1,.11-.47,1.17,1.17,0,0,1,.43-.39,2.81,2.81,0,0,1,1-.36,3.51,3.51,0,0,1,1,0,.77.77,0,0,1,0-.3.89.89,0,0,1,.11-.31,1.13,1.13,0,0,1,.22-.28,1.92,1.92,0,0,1,.31-.23,2.86,2.86,0,0,1,.89-.34,3.28,3.28,0,0,1,.88-.05,3.49,3.49,0,0,1,.85.19,4.93,4.93,0,0,1,.77.36l2.12,1.22a.14.14,0,0,1,0,.25l-.6.34a.46.46,0,0,1-.21.05.48.48,0,0,1-.22-.05l-2.07-1.2a2.11,2.11,0,0,0-.95-.31,1.55,1.55,0,0,0-.78.21.55.55,0,0,0-.33.43c0,.16.14.35.47.55l2.11,1.22a.12.12,0,0,1,0,.24l-.6.35a.41.41,0,0,1-.21.05.46.46,0,0,1-.21-.05l-2.07-1.2a1.92,1.92,0,0,0-1-.31,1.35,1.35,0,0,0-.78.21.55.55,0,0,0-.34.44c0,.17.16.36.52.56l2.07,1.19a.17.17,0,0,1,.08.13.15.15,0,0,1-.08.12l-.6.34a.47.47,0,0,1-.42,0l-3.66-2.11a.12.12,0,0,1,0-.24l.6-.35a.41.41,0,0,1,.21-.05.46.46,0,0,1,.21.05Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M243.06,263.55a.86.86,0,0,1-.21-.29.64.64,0,0,1,0-.39,1,1,0,0,1,.23-.45,2.05,2.05,0,0,1,.6-.47,4.34,4.34,0,0,1,.83-.36,4.17,4.17,0,0,1,.86-.14,2.88,2.88,0,0,1,.87.1,3.34,3.34,0,0,1,.84.33l2.31,1.33a.17.17,0,0,1,.08.13.14.14,0,0,1-.08.12l-.6.34a.36.36,0,0,1-.21.05.33.33,0,0,1-.21-.05l-.26-.15a.67.67,0,0,1-.09.5,1.6,1.6,0,0,1-.63.55,3,3,0,0,1-.69.3,2.91,2.91,0,0,1-.7.11,3.63,3.63,0,0,1-.67-.06,2.2,2.2,0,0,1-.59-.23c-.36-.21-.51-.45-.46-.71a1.52,1.52,0,0,1,.61-.84l1.06-.86a1,1,0,0,0-.67-.14,1.78,1.78,0,0,0-.66.22.81.81,0,0,0-.25.21.56.56,0,0,0-.06.21.5.5,0,0,1,0,.13.31.31,0,0,1-.11.08l-.73.43a.34.34,0,0,1-.18,0A.2.2,0,0,1,243.06,263.55Zm3.52.52a1.55,1.55,0,0,0,.4-.32.59.59,0,0,0,.15-.32.45.45,0,0,0-.07-.28.7.7,0,0,0-.25-.23l-.08-.05-.88.73a.78.78,0,0,0-.3.36c0,.09,0,.18.14.25a.61.61,0,0,0,.41,0A1.64,1.64,0,0,0,246.58,264.07Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M245.89,259a.47.47,0,0,1,.42,0l.61.35a.15.15,0,0,1,.09.12c0,.05,0,.09-.09.13l-.67.39a.46.46,0,0,1-.21.05.48.48,0,0,1-.22-.05l-.61-.36a.13.13,0,0,1,0-.24Zm5.53,3c.06,0,.09.08.09.13s0,.08-.09.12l-.6.34a.43.43,0,0,1-.21.05.36.36,0,0,1-.21-.05l-3.66-2.11a.14.14,0,0,1-.08-.12.12.12,0,0,1,.08-.12l.6-.35a.46.46,0,0,1,.21-.05.41.41,0,0,1,.21.05Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M253.52,260.81a.13.13,0,0,1,0,.24l-.59.35a.46.46,0,0,1-.21.05.48.48,0,0,1-.22-.05l-5.15-3a.17.17,0,0,1-.08-.13.15.15,0,0,1,.08-.12l.6-.34a.36.36,0,0,1,.21,0,.38.38,0,0,1,.22,0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M222.39,284.64l77.78-44.9a3.47,3.47,0,0,1,3.12-.19c.77.44.62,1.25-.33,1.8l-77.78,44.91a3.5,3.5,0,0,1-3.13.19C221.28,286,221.44,285.2,222.39,284.64Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-4"
                d="M227.85,287.8l77.78-44.9a3.48,3.48,0,0,1,3.12-.2c.78.45.62,1.25-.33,1.81l-77.78,44.9a3.5,3.5,0,0,1-3.13.2C226.75,289.16,226.9,288.35,227.85,287.8Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
          </g>
        </g>
        <g id="Character">
          <g id="Character_Envelope" data-name="Character Envelope">
            <polygon
              id="Shadow"
              className="cls-10"
              points="104.64 307.73 64.02 284.27 245.98 179.22 287.43 202.19 104.64 307.73"
            />
            <g id="Back">
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M101.39,170.73,274.45,70.81l6.92,4a7.24,7.24,0,0,1,3.26,5.64V208.11a7.22,7.22,0,0,1-3.26,5.64L114.83,309.91a7.24,7.24,0,0,1-6.51,0l-3.67-2.12a7.24,7.24,0,0,1-3.26-5.64Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M101.39,170.73,274.45,70.81l6.92,4a7.24,7.24,0,0,1,3.26,5.64V208.11a7.22,7.22,0,0,1-3.26,5.64L114.83,309.91a7.24,7.24,0,0,1-6.51,0l-3.67-2.12a7.24,7.24,0,0,1-3.26-5.64Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M273.49,59.59l.71-.38-2.69-1.57h0a5.19,5.19,0,0,0-.71-.35L194.64,29.08a5.26,5.26,0,0,0-5.85,1.86l-85.2,124.42a14.76,14.76,0,0,0-2.2,7.1v8.27l2.64,1.53L274.45,70.81V62.55A5.56,5.56,0,0,0,273.49,59.59Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-11"
                d="M192.31,31.54a4.63,4.63,0,0,0-.88.94l-85.2,124.41a13,13,0,0,0-1.58,3.56L102,158.92a15.49,15.49,0,0,1,.69-1.88l0-.06c.12-.26.24-.5.37-.75a.67.67,0,0,1,.06-.12,7.43,7.43,0,0,1,.45-.75L188.79,31a4.33,4.33,0,0,1,.42-.52c.15-.14.3-.29.46-.42Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-12"
                d="M274.17,59.19a4.08,4.08,0,0,0-.73-.35L197.27,30.61a5.23,5.23,0,0,0-5,.93L189.67,30a5.28,5.28,0,0,1,5-.93L270.8,57.3a4.25,4.25,0,0,1,.71.35Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M103.14,156.11a6.76,6.76,0,0,1,.45-.75A6.76,6.76,0,0,0,103.14,156.11Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M189.22,30.43a4.47,4.47,0,0,1,.45-.42A4.47,4.47,0,0,0,189.22,30.43Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M102,158.92a16.33,16.33,0,0,1,.7-1.89A16.33,16.33,0,0,0,102,158.92Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M102.71,157c.11-.26.24-.51.36-.75C103,156.47,102.82,156.72,102.71,157Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M102.69,157s0,0,0-.05S102.69,157,102.69,157Z"
                transform="translate(-7.74 -9.21)"
              />
              <polygon
                className="cls-8"
                points="94.25 149.71 94.25 149.71 94.25 149.71 94.25 149.71"
              />
              <polygon className="cls-8" points="181.93 20.8 181.93 20.8 181.93 20.8 181.93 20.8" />
              <path
                className="cls-8"
                d="M103.07,156.23a.75.75,0,0,1,.07-.12A.75.75,0,0,0,103.07,156.23Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M188.79,30.94a3.42,3.42,0,0,1,.43-.51A3.42,3.42,0,0,0,188.79,30.94Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M191.43,32.48l-85.2,124.41A14.83,14.83,0,0,0,104,164v8.26L277.09,72.34V64.08a6,6,0,0,0-3.65-5.24L197.28,30.62A5.23,5.23,0,0,0,191.43,32.48Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-13"
                d="M277.09,64.08a5.59,5.59,0,0,0-.93-2.91L104.65,160.45l0,0A12.86,12.86,0,0,0,104,164v8.26L277.09,72.34Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Paper">
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M269.7,29a2,2,0,0,0-.81-1.81l-5.29-3.05a2,2,0,0,0-2,.2L119.67,106.3a6.22,6.22,0,0,0-2.81,4.87v170a2,2,0,0,0,.82,1.82l5.27,3a2,2,0,0,0,2-.19l142-81.95A6.23,6.23,0,0,0,269.7,199Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-14"
                d="M269.7,29a2,2,0,0,0-.81-1.81l-5.29-3.05a2,2,0,0,0-2,.2L119.67,106.3a6.22,6.22,0,0,0-2.81,4.87v170a2,2,0,0,0,.82,1.82l5.27,3a2,2,0,0,0,2-.19l142-81.95A6.23,6.23,0,0,0,269.7,199Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M124.94,285.83l142-81.95A6.23,6.23,0,0,0,269.7,199V29c0-1.79-1.26-2.51-2.81-1.62l-141.95,82a6.23,6.23,0,0,0-2.81,4.87v170C122.13,286,123.39,286.72,124.94,285.83Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-15"
                d="M124.94,285.83l142-81.95A6.23,6.23,0,0,0,269.7,199V29c0-1.79-1.26-2.51-2.81-1.62l-141.95,82a6.23,6.23,0,0,0-2.81,4.87v170C122.13,286,123.39,286.72,124.94,285.83Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M122.13,284.2a2.11,2.11,0,0,0,.66,1.72c-1-.54-4.63-2.68-5.1-2.94a1.94,1.94,0,0,1-.83-1.81v-170a5.62,5.62,0,0,1,.83-2.76l5.27,3a5.72,5.72,0,0,0-.83,2.78Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-16"
                d="M122.13,284.2a2.11,2.11,0,0,0,.66,1.72c-1-.54-4.63-2.68-5.1-2.94a1.94,1.94,0,0,1-.83-1.81v-170a5.62,5.62,0,0,1,.83-2.76l5.27,3a5.72,5.72,0,0,0-.83,2.78Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-13"
                d="M122.13,284.2a2.11,2.11,0,0,0,.66,1.72c-1-.54-4.63-2.68-5.1-2.94a1.94,1.94,0,0,1-.83-1.81v-170a5.62,5.62,0,0,1,.83-2.76l5.27,3a5.72,5.72,0,0,0-.83,2.78Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Character-2" data-name="Character">
              <path
                className="cls-1"
                d="M173.93,155.72c-.62,15.82.44,49.71.44,49.71s16.77,5.06,28.16,3.18,35.77-19.16,35.77-19.16l-4.06-36.67Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M212.85,204.85,215.57,179c10.69-6.37,14.16-15.19,14.16-15.19-9.72,12.73-19.86,10.67-19.86,10.67v31.72C210.84,205.8,211.84,205.34,212.85,204.85Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-3"
                d="M240.93,108.08c2.72-13.77,3.95-32.06-8-35.42-3.12-.87-11.06-.26-11.06-.26L208.93,73c-7.19.91-17.27,2.34-19.91,3-6.94,1.71-9,13-12.11,38.14-1.94,15.72-3.6,28-3.6,43.3,12.68,11.37,52.33,6.89,61.35-.51C235,139.62,236,133.19,240.93,108.08Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M206.74,68.35c-.12,2.51,2.77,6.75,7.2,9.73s8.24,4.19,8.72,5.43c-2.1.39-4,1.43-5.56,5-1.49,3.44-1.48,3.55-6.59,0s-9.68-11.71-9.66-14.43,4-8,6-7.53Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M222.66,83.51c1.5-1.64,2.92-5.75,3.1-7.52l.65-6.45a3.44,3.44,0,0,1,1.77,1.15c.55.84,3.27,6.46,3.18,9.59s-.82,7.38-1.88,9.17-1.77-1.36-2.47-2.59C226.11,85.28,224.88,83.55,222.66,83.51Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M220.64,87.11s.25,11.33-.8,17.36a18.34,18.34,0,0,0,6.75-.18s-1.73,2.13-8.07,1.15C218.52,105.44,220.47,93.61,220.64,87.11Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M247.47,34.77a18,18,0,0,0-35.89-1.36l-8.17-5.81a6.38,6.38,0,0,0-5.26,1.93c-2.24,2.36-.86,9.61,2.07,16.69,0,0,2.95,12.91,4.09,15a5.87,5.87,0,0,0,3.43,2.68l-.28-7.86,32.67-2.35-3.23-2.3A18,18,0,0,0,247.47,34.77Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-17"
                fill={theme.skinColor}
                d="M207,46.72c-1,.63-2-1.55-3.85-2.67-1.6-.95-5.19-2.63-7.55,1.34-2.55,4.27,2.08,10.17,5.32,11.39,4.8,1.8,6.51-2,6.51-2l-1,20C213,86.72,232.35,86,225.76,76l.79-7.71s5.17.7,7.68.28c4.17-.71,6.76-4,8-8.6,1.93-7.31,2.62-13.2.68-27.48-2.13-15.66-20.38-15.55-30.14-9.21S207,46.72,207,46.72Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M246.85,17.86a6.74,6.74,0,0,0-4.41-.51,5.34,5.34,0,0,0-3.2-5.37,6.18,6.18,0,0,0-6.76.91c.44-1.59-1-3.21-2.62-3.57a8.62,8.62,0,0,0-4.81.8c-2.29.87-4.55,1.85-6.88,2.63-4.11,1.37-8.48,2.15-12.19,4.38a7.36,7.36,0,0,0-2.32,2,6.39,6.39,0,0,0-1,4.07,8.14,8.14,0,0,0,.2,1.4,3.68,3.68,0,0,0-1-.76,3.46,3.46,0,0,0-4.74,1.65l6.18,3.2c-.15,1.25-.31,2.5-.43,3.75-.34,3.29-1,7.14-.23,10.42a2.4,2.4,0,0,0,.4,1.1,19.54,19.54,0,0,1,3.22,3.13c.48.58,1.06,1.52,1.83,1.75a1.86,1.86,0,0,0,2.14-1,3.41,3.41,0,0,0,.07-1.46l-.6-6.1a3.49,3.49,0,0,1,.1-1.61,4.61,4.61,0,0,1,1.49-1.59,7,7,0,0,0,2.43-4.88,7.27,7.27,0,0,1,.16-1.75c.13-.43.47-1.1,1-1.1.95,0,6.13,1.12,7.43,1.3,6.78.93,14.06,1.11,20-2.22,2.33-1.29,6.25-4,6.66-6.86A3.84,3.84,0,0,0,246.85,17.86Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-9"
                d="M226.55,68.28s-9.37-1.75-12.66-3.44a10.7,10.7,0,0,1-4.58-4.4A14.61,14.61,0,0,0,212,65.67c2.43,3,14.35,5.09,14.35,5.09Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M226.15,45a1.76,1.76,0,1,1-1.78-1.8A1.78,1.78,0,0,1,226.15,45Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M222.74,38.49l-4.12,2a2.41,2.41,0,0,1,1.1-3.14A2.24,2.24,0,0,1,222.74,38.49Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-18"
                d="M222.79,56l7.43,2.66a3.89,3.89,0,0,1-5,2.53A4.13,4.13,0,0,1,222.79,56Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-9"
                d="M227.48,61.28A3.88,3.88,0,0,0,223.14,58a3.72,3.72,0,0,0-.48.11,4.06,4.06,0,0,0,2.57,3.11A3.77,3.77,0,0,0,227.48,61.28Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M242.24,39.85l-4-2.07a2.17,2.17,0,0,1,3-.94A2.28,2.28,0,0,1,242.24,39.85Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-2"
                d="M240.22,44.74a1.78,1.78,0,0,1-1.72,1.84,1.8,1.8,0,0,1-1.79-1.8,1.76,1.76,0,1,1,3.51,0Z"
                transform="translate(-7.74 -9.21)"
              />
              <polygon
                className="cls-9"
                points="223.53 34.43 223.88 45.78 230.57 44.23 223.53 34.43"
              />
            </g>
            <g id="Front">
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M280.24,209.81a1.35,1.35,0,0,1-.18.26L207.94,187.2a12.43,12.43,0,0,0-15.58,4.8l-77.1,114.59-2.85,1.65h0a2.3,2.3,0,0,1-2.2.24l79.29-118.11a12.46,12.46,0,0,1,15.59-4.81Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-19"
                d="M185.26,203.25l.18-.16-70.18,103.5-2.86,1.65h0a2.36,2.36,0,0,1-2.21.25l72.31-106.91Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-19"
                d="M280.24,209.82a1.75,1.75,0,0,1-.18.26L207.94,187.2a12.42,12.42,0,0,0-15.59,4.8l-2.85-1.66a12.45,12.45,0,0,1,15.57-4.78Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M284.57,79.63h0c-.16-.93-.65-1.19-1.29-.75a3.81,3.81,0,0,0-.83.86l-.36.5-71.17,108.2-10.62,14.8a6.06,6.06,0,0,1-5.86,2.19l-9.17-2.18-70-25.77a3.68,3.68,0,0,0-1.43-.06,3.27,3.27,0,0,0-.53.17l2.64-1.52,67.13,24.6,8.84,3.16a6,6,0,0,0,5.85-2.2l10.63-14.79,71.51-108.7a3,3,0,0,1,.81-.74l-6.19-3.57,2.6-1.49,4.28,2.47A7.46,7.46,0,0,1,284.57,79.63Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-19"
                d="M210.91,188.43l-10.63,14.81a6.06,6.06,0,0,1-5.85,2.19l-9.17-2.18.18-.16.44-.7,6,1.43a6,6,0,0,0,5.85-2.19L208.26,187Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-11"
                d="M281.37,74.8l-4.28-2.46-2.59,1.49,6.18,3.57h0a3,3,0,0,0-.81.74l-71.52,108.7-.1.14h0l2.65,1.44L282.07,80.24l.37-.51a3.36,3.36,0,0,1,.83-.85c.63-.44,1.13-.19,1.28.75h0A7.41,7.41,0,0,0,281.37,74.8Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M116.66,179.55l-15.27-8.82V302.15a7.24,7.24,0,0,0,3.26,5.64l3.67,2.12a7.24,7.24,0,0,0,6.51,0l1.83-1.06Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-7"
                d="M116.66,179.55l-15.27-8.82V302.15a7.24,7.24,0,0,0,3.26,5.64l3.67,2.12a7.24,7.24,0,0,0,6.51,0l1.83-1.06Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M284.63,80.45V208.11a6.61,6.61,0,0,1-1,3.29,7.13,7.13,0,0,1-1.91,2.15l-.13.06-.2.14L114.83,309.9h0a2.33,2.33,0,0,1-2.22.26,2,2,0,0,1-1-1.56,3.6,3.6,0,0,1,0-.58V180.36a2.83,2.83,0,0,1,3.66-2.88l70,25.77,9.17,2.18a6.06,6.06,0,0,0,5.86-2.19l10.62-14.8,71.17-108.2.36-.5C283.65,78.06,284.63,78.38,284.63,80.45Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M281.38,213.75a1.73,1.73,0,0,0,.21-.13l.12-.08a7,7,0,0,0,1.91-2.13,6.7,6.7,0,0,0,1-3.24l-73.71-19.73,49.36,37.49Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M281.38,213.75a1.73,1.73,0,0,0,.21-.13l.12-.08a7,7,0,0,0,1.91-2.13,6.7,6.7,0,0,0,1-3.24l-73.71-19.73,49.36,37.49Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M111.57,308a2.23,2.23,0,0,0,1,2.14,2.32,2.32,0,0,0,2.22-.25h0l57.34-33.1,13.1-73.55L111.58,305.9Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-7"
                d="M192.33,192,112.59,310.16a2.23,2.23,0,0,1-1-2.14V305.9l77.89-115.52,0,0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M283.62,211.41a7,7,0,0,1-1.91,2.13l-.12.08L114.83,309.9h0a2.32,2.32,0,0,1-2.22.25L192.34,192A12.52,12.52,0,0,1,208,187.16Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-7"
                d="M102,158.92l2.65,1.53A12.72,12.72,0,0,0,104,164v8.25l-2.65-1.53v-8.26A12.72,12.72,0,0,1,102,158.92Z"
                transform="translate(-7.74 -9.21)"
              />
              <polygon
                className="cls-5"
                fill={theme.accentColor[0]}
                points="108.17 166.85 105.54 168.38 102.86 166.84 96.28 163.05 98.84 161.53 108.17 166.85"
              />
              <path
                className="cls-11"
                d="M116,176.12l-9.45-5.38L104,172.26l6.57,3.79,2.68,1.54h0a2.09,2.09,0,0,1,.5-.16,3.44,3.44,0,0,1,1.42.05l5.32,2,61.13,22.51,1-1.42Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Arm">
              <path
                className="cls-17"
                fill={theme.skinColor}
                d="M189,76c-8.49.61-14.31,2.63-19.77,15.77-3.54,8.49-17.4,39-18.74,44.06-1.57,5.92-5.12,50.95-5.12,50.95l8.1,3s-2.77,9.69-5.12,15.22c-2.7,6.39,10.49,5.05,14.73-.75s7.12-13.57,4.8-16.3a38,38,0,0,0-6.42-5.94l8.86-40.17,18.59-39.52S198.26,83,189,76Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-9"
                d="M161.48,182.08a17.48,17.48,0,0,0-8.22-2.35,15.87,15.87,0,0,1,8.6,0Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M190.94,75.64c-4.76,0-13.65-.25-19.41,10.15S157.63,116,157.63,116s3.38,8.32,21.5,10.06L193,96.49S196.39,82.94,190.94,75.64Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
            <g id="Arm-2" data-name="Arm">
              <path
                className="cls-17"
                fill={theme.skinColor}
                d="M252.42,82.46c7.16,5.65,18.78,14.52,24.43,18.07,4.27-5.16,12.13-15.62,14-17.91C293.31,79.71,301,75,301,75l2.89,11.59s-14.52,26.78-19.78,31.73c-5.54,5.22-9.55,3.06-20.38-1.9-10.23-4.69-21.34-10.51-21.34-10.51,2.2-19.46.71-30-8.59-33.28C240,73.36,246.41,77.73,252.42,82.46Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M271.11,96.62c-3.74,1-11.47,12-10.06,19l-19.7-9.74c2.38-13.43,2.9-30-8.45-33.21a15.78,15.78,0,0,0-3.32-.42h0c5.65-.56,9.34-.39,15.26,4.06S271.11,96.62,271.11,96.62Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-9"
                d="M276.85,100.53c-2.82,2.48-3.73,6.94-4.28,8.71a15.54,15.54,0,0,1,2.65-9.77Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-1"
                d="M304.28,62l6.76-4.1s.77,36.45.8,37.63a4,4,0,0,0,1.42,2.34L306.5,102a4.05,4.05,0,0,1-1.42-2.34C305.06,98.42,304.28,62,304.28,62Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-17"
                fill={theme.skinColor}
                d="M311.36,73.07s1.94.46,2.68,3.47,1.12,8.76-.61,10.65-4.09,2.72-5.66,2c-2.93-1.27-2-7.22.31-8.6,3.76-2.19,3.31-4.61,3.31-4.61Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-3"
                d="M296,62.09l3,3.61.53,25.7-3,5,10,5.52a3.68,3.68,0,0,1-1.42-2.34l-.7-32.9Z"
                transform="translate(-7.74 -9.21)"
              />
              <polygon
                className="cls-5"
                fill={theme.accentColor[0]}
                points="288.71 87.21 288.75 88.79 298.79 94.31 298.76 92.73 288.71 87.21"
              />
              <polygon
                className="cls-5"
                fill={theme.accentColor[0]}
                points="298.79 94.31 305.55 90.22 305.51 88.64 298.76 92.73 298.79 94.31"
              />
              <polygon
                className="cls-11"
                points="298.79 94.31 305.55 90.22 305.51 88.64 298.76 92.73 298.79 94.31"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M297.94,44.26h0c-1.32-.33-2.84.22-4.25,1.73l-.05.06a14.14,14.14,0,0,0-2.89,12.47l0,.07c.62,2,1.78,3.2,3.15,3.45h0l5.84,1.4,3.57-17.88Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-16"
                d="M297.94,44.26h0c-1.32-.33-2.84.22-4.25,1.73l-.05.06a14.14,14.14,0,0,0-2.89,12.47l0,.07c.62,2,1.78,3.2,3.15,3.45h0l5.84,1.4,3.57-17.88Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-13"
                d="M293.92,62h0l5.84,1.4,1.18-5.93-10.62-2.46a11.17,11.17,0,0,0,.43,3.47l0,.07C291.39,60.61,292.55,61.79,293.92,62Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M309.77,44.76h0a5.31,5.31,0,0,0-4.75,1.7c-.17.15-.34.32-.51.5s-.38.42-.56.65a11.94,11.94,0,0,0-.86,1.21,16,16,0,0,0-1.3,2.51A19.4,19.4,0,0,0,300.34,59a13.65,13.65,0,0,0,.55,3.63c.73,2.39,2.06,3.83,3.65,4.25L299,65.57h0a6.43,6.43,0,0,1-4.4-4.42,13.84,13.84,0,0,1-.54-3.47,19.24,19.24,0,0,1,1.45-7.81,16.34,16.34,0,0,1,1.29-2.5,13.76,13.76,0,0,1,.86-1.21q.27-.34.57-.66a5.9,5.9,0,0,1,.51-.49,6.32,6.32,0,0,1,5.38-1.54h0l.16,0,.2.05Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-11"
                d="M299,65.57h0a6.43,6.43,0,0,1-4.4-4.42,13.84,13.84,0,0,1-.54-3.47l6.3,1.3a13.65,13.65,0,0,0,.55,3.63c.73,2.39,2.06,3.83,3.65,4.25Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M313.55,49.05c1.49,4.9-.13,11.9-3.63,15.64-1.75,1.88-3.65,2.58-5.29,2.19l-.09,0c-1.59-.42-2.92-1.86-3.65-4.25-1.49-4.9.13-11.9,3.62-15.64,1.75-1.87,3.63-2.57,5.26-2.2S312.8,46.59,313.55,49.05Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-8"
                d="M313.55,49.05c1.49,4.9-.13,11.9-3.63,15.64-1.75,1.88-3.65,2.58-5.29,2.19l-.09,0c-1.59-.42-2.92-1.86-3.65-4.25-1.49-4.9.13-11.9,3.62-15.64,1.75-1.87,3.63-2.57,5.26-2.2S312.8,46.59,313.55,49.05Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M336.71,40.6s-6.54,6.34-9.66,19.82a52.88,52.88,0,0,0-1.19,7.35C325,76.93,327,82.46,327,82.46c-4-4.95-8.69-9.93-14.85-12.95a76.77,76.77,0,0,0-7.39-3.13h0c-1.49-.35-2.72-1.72-3.39-3.92a13.79,13.79,0,0,1-.5-4.78,17.72,17.72,0,0,1,.45-3.21,15.78,15.78,0,0,1,3.56-7.15c1.57-1.68,3.28-2.38,4.77-2h0a77.92,77.92,0,0,0,8,.44C324.53,45.7,330.91,43.27,336.71,40.6Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-16"
                d="M336.71,40.6s-6.54,6.34-9.66,19.82a52.88,52.88,0,0,0-1.19,7.35C325,76.93,327,82.46,327,82.46c-4-4.95-8.69-9.93-14.85-12.95a76.77,76.77,0,0,0-7.39-3.13h0c-1.49-.35-2.72-1.72-3.39-3.92a13.79,13.79,0,0,1-.5-4.78,17.72,17.72,0,0,1,.45-3.21,15.78,15.78,0,0,1,3.56-7.15c1.57-1.68,3.28-2.38,4.77-2h0a77.92,77.92,0,0,0,8,.44C324.53,45.7,330.91,43.27,336.71,40.6Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-13"
                d="M325.86,67.77C325,76.93,327,82.46,327,82.46c-4-4.95-8.69-9.93-14.85-12.95a76.77,76.77,0,0,0-7.39-3.13h0c-1.49-.35-2.72-1.72-3.39-3.92a13.79,13.79,0,0,1-.5-4.78C307.64,58.82,318.79,61.35,325.86,67.77Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M354.67,47.21a37.74,37.74,0,0,1,.65,17.14h0C354,72,350.71,79.43,346,84.43c-8.31,8.91-17.93,6.67-21.49-5a32.74,32.74,0,0,1-1.31-8.63,45.63,45.63,0,0,1,5.35-22.14c.51-.92,1-1.8,1.6-2.65l.72-1h0c.35-.49.7-1,1.07-1.4s.78-.93,1.19-1.36C341.5,33.33,351.12,35.55,354.67,47.21Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-11"
                d="M355.32,64.35C354,72,350.71,79.43,346,84.43c-8.31,8.91-17.93,6.67-21.49-5a32.74,32.74,0,0,1-1.31-8.63h0c1.14,1.3,4.25,2.7,4.89.86a29.46,29.46,0,0,0,1.17,7.65c1,3.35,2.59,5.83,4.54,7.16a6.26,6.26,0,0,0,5.61.78,14.65,14.65,0,0,0,6.08-4.17c4-4.25,6.88-10.61,8.3-17.23C353.84,65.87,354.63,66.21,355.32,64.35Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M353.62,48.24c1.57,5.15,1.53,11.51.22,17.63-1.42,6.62-4.32,13-8.3,17.23a14.65,14.65,0,0,1-6.08,4.17,6.26,6.26,0,0,1-5.61-.78c-2-1.33-3.52-3.81-4.54-7.16a29.46,29.46,0,0,1-1.17-7.65c0-1,0-2.07,0-3.12a40.75,40.75,0,0,1,.66-5.55c.07-.38.14-.76.22-1.13.13-.63.27-1.26.43-1.88a43.23,43.23,0,0,1,2.06-6.16l0-.07A38.57,38.57,0,0,1,333.42,50c.48-.86,1-1.68,1.52-2.46l.69-1c.29-.37.58-.74.87-1.09s.59-.68.89-1a14.55,14.55,0,0,1,6.08-4.17C347.9,39,351.7,41.93,353.62,48.24Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-20"
                d="M353.62,48.24c1.57,5.15,1.53,11.51.22,17.63-1.42,6.62-4.32,13-8.3,17.23a14.65,14.65,0,0,1-6.08,4.17,6.26,6.26,0,0,1-5.61-.78c-2-1.33-3.52-3.81-4.54-7.16a29.46,29.46,0,0,1-1.17-7.65c0-1,0-2.07,0-3.12a40.75,40.75,0,0,1,.66-5.55c.07-.38.14-.76.22-1.13.13-.63.27-1.26.43-1.88a43.23,43.23,0,0,1,2.06-6.16l0-.07A38.57,38.57,0,0,1,333.42,50c.48-.86,1-1.68,1.52-2.46l.69-1c.29-.37.58-.74.87-1.09s.59-.68.89-1a14.55,14.55,0,0,1,6.08-4.17C347.9,39,351.7,41.93,353.62,48.24Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M339,55.84,336.2,69.76c-2-.12-5.39-.28-8.06-.15,0-.35,0-.7,0-1a42.39,42.39,0,0,1,.66-5.55c.07-.38.15-.75.22-1.13.13-.63.28-1.26.44-1.87a43.33,43.33,0,0,1,2.05-6.17.21.21,0,0,0,0-.07c.13-.29.25-.58.38-.86A43.29,43.29,0,0,0,339,55.84Z"
                transform="translate(-7.74 -9.21)"
              />
              <g className="cls-21">
                <path
                  className="cls-22"
                  d="M339,55.84,336.2,69.76c-2-.12-5.39-.28-8.06-.15,0-.35,0-.7,0-1a42.39,42.39,0,0,1,.66-5.55c.07-.38.15-.75.22-1.13.13-.63.28-1.26.44-1.87a43.33,43.33,0,0,1,2.05-6.17.21.21,0,0,0,0-.07c.13-.29.25-.58.38-.86A43.29,43.29,0,0,0,339,55.84Z"
                  transform="translate(-7.74 -9.21)"
                />
              </g>
              <path
                className="cls-5"
                fill={theme.accentColor[0]}
                d="M336.73,69.57c-1.45.44-2.68-.46-3.27-2.43l0-.06a11.2,11.2,0,0,1,2.28-9.86l0,0a4.35,4.35,0,0,1,1.83-1.25c1.45-.44,2.67.47,3.27,2.43v.06a11.19,11.19,0,0,1-2.28,9.86l0,0a4.48,4.48,0,0,1-1.83,1.24Z"
                transform="translate(-7.74 -9.21)"
              />
              <g className="cls-23">
                <path
                  className="cls-22"
                  d="M336.73,69.57c-1.45.44-2.68-.46-3.27-2.43l0-.06a11.2,11.2,0,0,1,2.28-9.86l0,0a4.35,4.35,0,0,1,1.83-1.25c1.45-.44,2.67.47,3.27,2.43v.06a11.19,11.19,0,0,1-2.28,9.86l0,0a4.48,4.48,0,0,1-1.83,1.24Z"
                  transform="translate(-7.74 -9.21)"
                />
              </g>
              <path
                className="cls-10"
                d="M333.36,33.74a1.49,1.49,0,0,1-1.88-1L327.23,18.8a1.51,1.51,0,0,1,2.88-.88l4.25,13.94A1.49,1.49,0,0,1,333.36,33.74Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M321.71,41a1.51,1.51,0,0,1-1.47-.34l-10.65-10a1.51,1.51,0,0,1,2.06-2.2l10.65,10a1.5,1.5,0,0,1,.07,2.13A1.39,1.39,0,0,1,321.71,41Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M329,112.23a1.58,1.58,0,0,1-.78,0,1.51,1.51,0,0,1-1.13-1.81l3.29-14.2a1.51,1.51,0,1,1,2.94.68L330,111.13A1.51,1.51,0,0,1,329,112.23Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M355.45,106.21a1.51,1.51,0,0,1-1.88-1l-4.25-13.94a1.51,1.51,0,1,1,2.88-.88l4.25,13.94A1.51,1.51,0,0,1,355.45,106.21Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M371.14,87.18a1.51,1.51,0,0,1-1.47-.34L359,76.89a1.51,1.51,0,0,1,2.05-2.21l10.66,9.95a1.5,1.5,0,0,1,.07,2.13A1.55,1.55,0,0,1,371.14,87.18Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M381.14,68.4a1.57,1.57,0,0,1-.78,0l-14.2-3.29A1.52,1.52,0,0,1,365,63.33a1.5,1.5,0,0,1,1.81-1.13L381,65.49a1.51,1.51,0,0,1,.1,2.91Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M380.42,47.13l-13.95,4.25a1.5,1.5,0,0,1-1.88-1,1.51,1.51,0,0,1,1-1.88l14-4.25a1.51,1.51,0,0,1,.88,2.88Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M359.21,39.73a1.51,1.51,0,0,1-1.55-2.47l9.95-10.65a1.51,1.51,0,0,1,2.21,2.06l-9.95,10.65A1.5,1.5,0,0,1,359.21,39.73Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-10"
                d="M347.08,33.28a1.54,1.54,0,0,1-.77,0,1.5,1.5,0,0,1-1.13-1.81l3.29-14.2a1.51,1.51,0,1,1,2.94.68l-3.29,14.2A1.54,1.54,0,0,1,347.08,33.28Z"
                transform="translate(-7.74 -9.21)"
              />
              <path
                className="cls-17"
                fill={theme.skinColor}
                d="M290.89,82.62c2.87-3.64,3-5.93,5.22-7.72S300.61,73,304,74c2.51.72,5.46.36,6.48,1.29.29.2-.16,1.81-1.34,2.39-1.42.7-3.72.53-5.41.54-3.86,0-.69,3.8-4.41,7.64C297.7,88.57,290.89,82.62,290.89,82.62Z"
                transform="translate(-7.74 -9.21)"
              />
            </g>
          </g>
        </g>
        <g id="Icon">
          <g id="At">
            <path
              className="cls-5"
              fill={theme.accentColor[0]}
              d="M303,362.38a1,1,0,0,0-.52-.89,3.26,3.26,0,0,0-2.2-.65,5.13,5.13,0,0,0-2.32.56l-4,2.13a7.14,7.14,0,0,0,.73-1.83,6.27,6.27,0,0,0,.16-1.5c0-.84,0-5.5,0-5.94a7,7,0,0,0-.6-2.76,10.64,10.64,0,0,0-3.58-4.05c-1.23-.94-2.7-2-4.43-3.11s-3.29-2.08-4.7-2.87a57.82,57.82,0,0,0-11.84-4.72A49.3,49.3,0,0,0,256,335a63.64,63.64,0,0,0-15.56,2.22,81,81,0,0,0-17.41,7q-7.83,4.14-11.81,8.61a18.84,18.84,0,0,0-4.83,8.81,12.74,12.74,0,0,0-.25,2.66c0,1,0,5.19,0,6a13,13,0,0,0,1.42,5.83,21.53,21.53,0,0,0,6.2,7.3c.59.46,1.44,1.07,2.56,1.84s2.31,1.57,3.59,2.4,2.5,1.63,3.71,2.38,2.18,1.34,2.94,1.77a49.79,49.79,0,0,0,11.89,4.38,58.89,58.89,0,0,0,14,1.54,65.9,65.9,0,0,0,15.18-1.92,74.85,74.85,0,0,0,25.7-12.34,34.89,34.89,0,0,0,5.81-5.57,15.72,15.72,0,0,0,2.79-4.93,30.15,30.15,0,0,0,1.05-4.37,1.37,1.37,0,0,0,0-.19C303,368.14,303,362.44,303,362.38Zm-15,7.18a16.74,16.74,0,0,1-2.3,2.6,33,33,0,0,1-3.89,3,67.26,67.26,0,0,1-6.09,3.57,47.68,47.68,0,0,1-10.58,4.15,47.11,47.11,0,0,1-10.54,1.51,42.91,42.91,0,0,1-10-.89,36.56,36.56,0,0,1-8.92-3.07,29.49,29.49,0,0,1-2.92-1.65c-1.13-.7-2.28-1.43-3.45-2.2s-2.28-1.51-3.32-2.23a21.61,21.61,0,0,1-2.36-1.81,15.76,15.76,0,0,1-4.33-5.6c-.09-.23-.18-.45-.26-.68a14.49,14.49,0,0,1,3.41-5.18,32.4,32.4,0,0,1,8.1-5.77,68.57,68.57,0,0,1,11.79-5,47.73,47.73,0,0,1,6-1.44l-1,.55a1.85,1.85,0,0,0-1.11,1.3,1.3,1.3,0,0,0,.7,1.31l.68.44a21.63,21.63,0,0,0-5.33,0,19.12,19.12,0,0,0-6.41,2.29,13.5,13.5,0,0,0-4.85,3.9,6.5,6.5,0,0,0-1.34,3.85c0,.19,0,5.12,0,6.14a5.24,5.24,0,0,0,0,.56,9.18,9.18,0,0,0,2,4.64,21.21,21.21,0,0,0,5.27,4.61,31.26,31.26,0,0,0,7.28,3.55,31.92,31.92,0,0,0,7.79,1.59,29.29,29.29,0,0,0,7.73-.42,25,25,0,0,0,7.11-2.48,26.47,26.47,0,0,0,4.3-2.72,10.17,10.17,0,0,0,2.17-2.3,4.46,4.46,0,0,0,.71-2c.05-.61.05-1.21,0-1.79a26.91,26.91,0,0,0,6.09-.43,27.57,27.57,0,0,0,8-3l.46-.27Q288.46,368.92,288,369.56Zm-35.69-5.89a17.39,17.39,0,0,1,7.39,2.86,17.19,17.19,0,0,1,2.23,1.72,11.29,11.29,0,0,1-1.17.72,11.59,11.59,0,0,1-6.87,1.25,16.91,16.91,0,0,1-7.4-2.82,14.72,14.72,0,0,1-2.28-1.78,7.91,7.91,0,0,1,1-.66A11.6,11.6,0,0,1,252.34,363.67Zm27.87-5.93a9.85,9.85,0,0,1-3.58.8,6.94,6.94,0,0,1-4.16-1.08l-13.54-8.87a34.62,34.62,0,0,1,4.05.7,41.92,41.92,0,0,1,9.51,3.56,50.57,50.57,0,0,1,4.42,2.58C278.1,356.21,279.18,357,280.21,357.74Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-8"
              d="M303,362.38a1,1,0,0,0-.52-.89,3.26,3.26,0,0,0-2.2-.65,5.13,5.13,0,0,0-2.32.56l-4,2.13a7.14,7.14,0,0,0,.73-1.83,6.27,6.27,0,0,0,.16-1.5c0-.84,0-5.5,0-5.94a7,7,0,0,0-.6-2.76,10.64,10.64,0,0,0-3.58-4.05c-1.23-.94-2.7-2-4.43-3.11s-3.29-2.08-4.7-2.87a57.82,57.82,0,0,0-11.84-4.72A49.3,49.3,0,0,0,256,335a63.64,63.64,0,0,0-15.56,2.22,81,81,0,0,0-17.41,7q-7.83,4.14-11.81,8.61a18.84,18.84,0,0,0-4.83,8.81,12.74,12.74,0,0,0-.25,2.66c0,1,0,5.19,0,6a13,13,0,0,0,1.42,5.83,21.53,21.53,0,0,0,6.2,7.3c.59.46,1.44,1.07,2.56,1.84s2.31,1.57,3.59,2.4,2.5,1.63,3.71,2.38,2.18,1.34,2.94,1.77a49.79,49.79,0,0,0,11.89,4.38,58.89,58.89,0,0,0,14,1.54,65.9,65.9,0,0,0,15.18-1.92,74.85,74.85,0,0,0,25.7-12.34,34.89,34.89,0,0,0,5.81-5.57,15.72,15.72,0,0,0,2.79-4.93,30.15,30.15,0,0,0,1.05-4.37,1.37,1.37,0,0,0,0-.19C303,368.14,303,362.44,303,362.38Zm-15,7.18a16.74,16.74,0,0,1-2.3,2.6,33,33,0,0,1-3.89,3,67.26,67.26,0,0,1-6.09,3.57,47.68,47.68,0,0,1-10.58,4.15,47.11,47.11,0,0,1-10.54,1.51,42.91,42.91,0,0,1-10-.89,36.56,36.56,0,0,1-8.92-3.07,29.49,29.49,0,0,1-2.92-1.65c-1.13-.7-2.28-1.43-3.45-2.2s-2.28-1.51-3.32-2.23a21.61,21.61,0,0,1-2.36-1.81,15.76,15.76,0,0,1-4.33-5.6c-.09-.23-.18-.45-.26-.68a14.49,14.49,0,0,1,3.41-5.18,32.4,32.4,0,0,1,8.1-5.77,68.57,68.57,0,0,1,11.79-5,47.73,47.73,0,0,1,6-1.44l-1,.55a1.85,1.85,0,0,0-1.11,1.3,1.3,1.3,0,0,0,.7,1.31l.68.44a21.63,21.63,0,0,0-5.33,0,19.12,19.12,0,0,0-6.41,2.29,13.5,13.5,0,0,0-4.85,3.9,6.5,6.5,0,0,0-1.34,3.85c0,.19,0,5.12,0,6.14a5.24,5.24,0,0,0,0,.56,9.18,9.18,0,0,0,2,4.64,21.21,21.21,0,0,0,5.27,4.61,31.26,31.26,0,0,0,7.28,3.55,31.92,31.92,0,0,0,7.79,1.59,29.29,29.29,0,0,0,7.73-.42,25,25,0,0,0,7.11-2.48,26.47,26.47,0,0,0,4.3-2.72,10.17,10.17,0,0,0,2.17-2.3,4.46,4.46,0,0,0,.71-2c.05-.61.05-1.21,0-1.79a26.91,26.91,0,0,0,6.09-.43,27.57,27.57,0,0,0,8-3l.46-.27Q288.46,368.92,288,369.56Zm-35.69-5.89a17.39,17.39,0,0,1,7.39,2.86,17.19,17.19,0,0,1,2.23,1.72,11.29,11.29,0,0,1-1.17.72,11.59,11.59,0,0,1-6.87,1.25,16.91,16.91,0,0,1-7.4-2.82,14.72,14.72,0,0,1-2.28-1.78,7.91,7.91,0,0,1,1-.66A11.6,11.6,0,0,1,252.34,363.67Zm27.87-5.93a9.85,9.85,0,0,1-3.58.8,6.94,6.94,0,0,1-4.16-1.08l-13.54-8.87a34.62,34.62,0,0,1,4.05.7,41.92,41.92,0,0,1,9.51,3.56,50.57,50.57,0,0,1,4.42,2.58C278.1,356.21,279.18,357,280.21,357.74Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-11"
              d="M219.11,366.3a14.49,14.49,0,0,1,3.41-5.18,32.4,32.4,0,0,1,8.1-5.77,68.57,68.57,0,0,1,11.79-5,47.73,47.73,0,0,1,6-1.44l3.64-1.93a4.74,4.74,0,0,1,2.31-.51,3.94,3.94,0,0,1,2.14.55l2.4,1.57a34.62,34.62,0,0,1,4.05.7,41.92,41.92,0,0,1,9.51,3.56,50.57,50.57,0,0,1,4.42,2.58c1.19.78,2.27,1.55,3.3,2.31a5.1,5.1,0,0,0,.58-.26,3.6,3.6,0,0,0,2.09-2.3c.2-.9-.44-1.91-1.92-3-1.23-.94-2.58-1.9-4-2.86a46,46,0,0,0-4.42-2.58,41,41,0,0,0-9.51-3.56,35,35,0,0,0-9.92-.91,43.44,43.44,0,0,0-10.65,2,68.66,68.66,0,0,0-11.79,5,32.14,32.14,0,0,0-8.1,5.76,13.63,13.63,0,0,0-3.66,6,9.16,9.16,0,0,0,.51,6,13.7,13.7,0,0,0,1.72,2.88,13.7,13.7,0,0,1-1.72-2.88C219.28,366.75,219.19,366.53,219.11,366.3Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-11"
              d="M259.73,360.4a17.41,17.41,0,0,0-7.39-2.87,11.61,11.61,0,0,0-7.05,1.3c-2.1,1.11-3,2.41-2.79,3.91a5.3,5.3,0,0,0,1.75,2.89h0a8.62,8.62,0,0,1,1-.66,11.6,11.6,0,0,1,7.05-1.29,17.39,17.39,0,0,1,7.39,2.86,17.19,17.19,0,0,1,2.23,1.72l-.53.35q2.64-1.62,2.36-3.57C263.57,363.58,262.23,362,259.73,360.4Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-11"
              d="M252.16,377.54a32.18,32.18,0,0,1-15.07-5.14,21,21,0,0,1-5.27-4.62,9.15,9.15,0,0,1-2-4.63,6.61,6.61,0,0,1,0-.89c0,.11,0,.21,0,.32s0,5.12,0,6.14a5.24,5.24,0,0,0,0,.56,9.18,9.18,0,0,0,2,4.64,21.21,21.21,0,0,0,5.27,4.61,31.26,31.26,0,0,0,7.28,3.55,31.92,31.92,0,0,0,7.79,1.59Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-11"
              d="M274.22,365.84c0,.59,0,1.18,0,1.79l0,4.35a26.91,26.91,0,0,0,6.09-.43v-6.14A26.34,26.34,0,0,1,274.22,365.84Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-11"
              d="M238.49,390.14a49.36,49.36,0,0,1-11.89-4.38c-.76-.42-1.74-1-2.94-1.76s-2.44-1.55-3.71-2.38-2.47-1.64-3.59-2.4-2-1.38-2.56-1.84a21.56,21.56,0,0,1-6.2-7.31,13,13,0,0,1-1.41-5.86c0,.05,0,.09,0,.14,0,1,0,5.19,0,6a13,13,0,0,0,1.42,5.83,21.53,21.53,0,0,0,6.2,7.3c.59.46,1.44,1.07,2.56,1.84s2.31,1.57,3.59,2.4,2.5,1.63,3.71,2.38,2.18,1.34,2.94,1.77a49.79,49.79,0,0,0,11.89,4.38,58.89,58.89,0,0,0,14,1.54v-6.13A58.88,58.88,0,0,1,238.49,390.14Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-5"
              fill={theme.accentColor[0]}
              d="M290.68,347.45a10.64,10.64,0,0,1,3.58,4.05,6.39,6.39,0,0,1,.44,4.07,8.37,8.37,0,0,1-2.15,3.75,15.94,15.94,0,0,1-4.2,3.11,27.29,27.29,0,0,1-8,3,26.34,26.34,0,0,1-6.09.43c0,.59,0,1.18,0,1.79a4.38,4.38,0,0,1-.71,2,10,10,0,0,1-2.17,2.3,26.42,26.42,0,0,1-4.3,2.73,25.33,25.33,0,0,1-7.11,2.48,29.29,29.29,0,0,1-7.73.42,32.18,32.18,0,0,1-15.07-5.14,21,21,0,0,1-5.27-4.62,9.15,9.15,0,0,1-2-4.63,6.38,6.38,0,0,1,1.31-4.42,13.5,13.5,0,0,1,4.85-3.9,19.12,19.12,0,0,1,6.41-2.29,21.63,21.63,0,0,1,5.33,0l-.68-.44a1.3,1.3,0,0,1-.7-1.31,1.85,1.85,0,0,1,1.11-1.3l4.67-2.48a4.74,4.74,0,0,1,2.31-.51,3.94,3.94,0,0,1,2.14.55l15.94,10.44a6.92,6.92,0,0,0,4.16,1.08,9.58,9.58,0,0,0,4.16-1.06,3.6,3.6,0,0,0,2.09-2.3c.2-.9-.44-1.91-1.92-3-1.23-.94-2.58-1.9-4-2.86a46,46,0,0,0-4.42-2.58,41,41,0,0,0-9.51-3.56,35,35,0,0,0-9.91-.91,43.43,43.43,0,0,0-10.66,2,68.66,68.66,0,0,0-11.79,5,32.14,32.14,0,0,0-8.1,5.76,13.63,13.63,0,0,0-3.66,6,9.16,9.16,0,0,0,.51,6,15.76,15.76,0,0,0,4.33,5.6,21.61,21.61,0,0,0,2.36,1.81c1,.72,2.15,1.46,3.32,2.23s2.32,1.5,3.45,2.2a29.49,29.49,0,0,0,2.92,1.65,36.56,36.56,0,0,0,8.92,3.07,42.91,42.91,0,0,0,10,.89,47.11,47.11,0,0,0,10.54-1.51,47.68,47.68,0,0,0,10.58-4.15,67.26,67.26,0,0,0,6.09-3.57,33,33,0,0,0,3.89-3,15.16,15.16,0,0,0,3.59-4.83,9.22,9.22,0,0,1,.72-1.4,3.58,3.58,0,0,1,1.31-1L298,361.4a5.13,5.13,0,0,1,2.32-.56,3.26,3.26,0,0,1,2.2.65,1,1,0,0,1,.5,1.07,30.15,30.15,0,0,1-1.05,4.37,15.83,15.83,0,0,1-2.79,4.93,35.29,35.29,0,0,1-5.81,5.56,67.8,67.8,0,0,1-10.05,6.31,67,67,0,0,1-15.65,6,65.93,65.93,0,0,1-15.18,1.93,58.88,58.88,0,0,1-14-1.55,49.36,49.36,0,0,1-11.89-4.38c-.76-.42-1.74-1-2.94-1.76s-2.44-1.55-3.71-2.38-2.47-1.64-3.59-2.4-2-1.38-2.56-1.84a21.56,21.56,0,0,1-6.2-7.31,12.85,12.85,0,0,1-1.17-8.38,18.84,18.84,0,0,1,4.83-8.81q4-4.47,11.81-8.61a81,81,0,0,1,17.41-7A63.64,63.64,0,0,1,256,335a49.3,49.3,0,0,1,13.67,1.71,57.82,57.82,0,0,1,11.84,4.72q2.11,1.18,4.7,2.87C288,345.47,289.45,346.51,290.68,347.45ZM246.52,367.4a16.91,16.91,0,0,0,7.4,2.82,11.59,11.59,0,0,0,6.87-1.25c2.21-1.17,3.21-2.49,3-3.94s-1.56-3-4.06-4.63a17.41,17.41,0,0,0-7.39-2.87,11.61,11.61,0,0,0-7.05,1.3c-2.1,1.11-3,2.41-2.79,3.91S244.08,365.8,246.52,367.4Z"
              transform="translate(-7.74 -9.21)"
            />
          </g>
        </g>
        <g id="Envelope">
          <g id="Mail">
            <path
              className="cls-5"
              fill={theme.accentColor[0]}
              d="M292.08,320.21v.73a4.08,4.08,0,0,0,1.84,3.2L333.5,347a4.07,4.07,0,0,0,3.69,0l65.54-37.84a4.08,4.08,0,0,0,1.84-3.2v-.73a4.08,4.08,0,0,0-1.84-3.2l-39.58-22.85a4.07,4.07,0,0,0-3.69,0L293.92,317A4.08,4.08,0,0,0,292.08,320.21Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-5"
              fill={theme.accentColor[0]}
              d="M292.08,320.21v.73a4.08,4.08,0,0,0,1.84,3.2L333.5,347a4.07,4.07,0,0,0,3.69,0l65.54-37.84a4.08,4.08,0,0,0,1.84-3.2v-.73a4.08,4.08,0,0,0-1.84-3.2l-39.58-22.85a4.07,4.07,0,0,0-3.69,0L293.92,317A4.08,4.08,0,0,0,292.08,320.21Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-8"
              d="M335.34,293.09,293.92,317a4.08,4.08,0,0,0-1.84,3.2v.73a4.08,4.08,0,0,0,1.84,3.2L333.5,347a3.82,3.82,0,0,0,1.84.44h0Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-7"
              d="M335.34,293.09,293.92,317a4.08,4.08,0,0,0-1.84,3.2v.73a4.08,4.08,0,0,0,1.84,3.2L333.5,347a3.82,3.82,0,0,0,1.84.44h0Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-8"
              d="M402.73,302l-39.58-22.85a4.07,4.07,0,0,0-3.69,0l-24.12,13.92v54.34h0a3.83,3.83,0,0,0,1.85-.44l65.54-37.84a4.08,4.08,0,0,0,1.84-3.2v-.73A4.08,4.08,0,0,0,402.73,302Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-5"
              fill={theme.accentColor[0]}
              d="M327.16,338.33l-33.24-19.19a1.12,1.12,0,0,1,0-2.13l65.54-37.84a4.07,4.07,0,0,1,3.69,0L402.73,302a1.12,1.12,0,0,1,0,2.13l-10.88,6.28-3.8,2.2L337.19,342a4.07,4.07,0,0,1-3.69,0l-3.23-1.86Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-7"
              d="M357.34,306.45,402.73,302l-45,2.55,5.41-25.4a3.79,3.79,0,0,0-2-.42l-8.49,34.33L293.17,318a1.24,1.24,0,0,0,.75,1.15l48-2.79-6.62,26.08,8.46-26.18h0l8.2-.48a4.48,4.48,0,0,0,2.71-1.13h0a4.42,4.42,0,0,0,1.38-2.38Z"
              transform="translate(-7.74 -9.21)"
            />
            <path
              className="cls-6"
              d="M307.36,316.81l45.29-3.73,1.62-6.49.9-3.61,6-24.23a3.66,3.66,0,0,0-1.68.42l-32.77,18.92L293.92,317a1.34,1.34,0,0,0-.75,1l9.09-.75Z"
              transform="translate(-7.74 -9.21)"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

Contactformsvg.propTypes = {
  theme: PropTypes.object
};
